<template>
  <loadable-chart-card :load-data="loadData()" :enable-data-toggle="false">
    <template v-slot:default="slotProps">
      <div class="chartElem" v-show="slotProps.chartMode">
        <highcharts class="chart" :options="chartOptions" />
      </div>
    </template>
  </loadable-chart-card>
</template>

<script>
import LoadableChartCard from '@/components/LoadableChartCard.vue'

export default {
  components: { LoadableChartCard },
  props: {
    teachers: { type: Array, required: true }
  },
  data() {
    return {
      chartOptions: {
        chart: { type: 'pie' },
        title: { text: 'Percent of Teachers Receiving Merit Bonus' },
        colors: [
          '#bbdefb', // Growth (light blue)
          '#ffe0b2', // Shortage Area (light orange)
          '#e1bee7'  // Mentor (light purple)
        ],
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f}%)',
              style: {
                fontSize: '12px',
                fontWeight: 'normal'
              }
            }
          }
        },
        series: [{ name: 'Teachers', colorByPoint: true, data: [] }]
      }
    }
  },
  methods: {
    loadData() {
      const growth = Array.isArray(this.teachers) ? this.teachers.filter(t => t.outstandingGrowthBonus && t.outstandingGrowthBonus > 0).length : 0
      const shortage = Array.isArray(this.teachers) ? this.teachers.filter(t => t.overallShortageAreaBonus && t.overallShortageAreaBonus > 0).length : 0
      const mentor = Array.isArray(this.teachers) ? this.teachers.filter(t => t.mentorBonus && t.mentorBonus > 0).length : 0
      this.chartOptions.series[0].data = [
        { name: 'Growth', y: growth },
        { name: 'Shortage Area', y: shortage },
        { name: 'Mentor', y: mentor }
      ]
      return Promise.resolve()
    },
    dataItems() {
      return this.chartOptions.series[0].data.map(item => ({ Category: item.name, Count: item.y }))
    }
  },
  watch: {
    teachers: {
      handler() { this.loadData() },
      immediate: true
    }
  }
}
</script>
